module.exports = __webpack_public_path__ + "static/media/location.8d90d6e5.svg";